import tesla from './img/tesla.jpeg';
import tesla2 from './img/tesla2.jpeg';
import teslaLeftSide from './img/tesla-left-side.jpeg';
import nightLights from './img/night-lights.jpeg';
import teslaRearFalconDoors from './img/tesla-rear-falcon-doors.jpeg';
import teslaSunroofTower from './img/tesla-sunroof-tower.jpeg';
import teslaTrunkSunroof from './img/tesla-trunk-sunroof.jpeg';
import teslaRearSeats from './img/tesla-rear-seats.jpeg';
import teslaCargoSeats from './img/tesla-cargo-seats.jpeg';
import teslaInteriorConsole from './img/tesla-interior-console.jpeg';

const vehicles = [
  {
    slug: 'tesla-model-x',
    name: 'Tesla Model X',
    year: 2019,
    status: 'available',
    price: '$129/day',
    images: [
      tesla,
      teslaRearFalconDoors,
      tesla2,
      teslaLeftSide,
      nightLights,
      teslaSunroofTower,
      teslaTrunkSunroof,
      teslaRearSeats,
      teslaCargoSeats,
      teslaInteriorConsole,
    ],
    imageAlt: 'Tesla Model X',
    specs: { range: '200 miles', seats: 7, drivetrain: 'AWD' },
  },
  {
    slug: 'volvo-xc90-t6',
    name: 'Volvo XC90 T6',
    status: 'available',
    price: '$99/day',
    images: [],
    imageAlt: 'Volvo XC90 T6',
    specs: { range: 'Hybrid', seats: 7, drivetrain: 'AWD' },
  },
  {
    slug: 'tesla-cybertruck',
    name: 'Tesla Cybertruck',
    status: 'coming-soon',
    price: null,
    images: [],
    imageAlt: 'Tesla Cybertruck',
    specs: { range: 'Electric', seats: 6, drivetrain: 'AWD' },
  },
];

export default vehicles;
